import Vue from "vue";
var geojsonArea = require("@mapbox/geojson-area");
const DIFF = 0.01;
const PRECISION = 0.000001;
// 初始化高德地图
const initGaode = function(mDiv) {
  return new Promise(resolve => {
    if (typeof AMap != "undefined") {
      newGaodeMap(mDiv).then(map => {
        resolve(map);
      });
    } else {
      let m = document.createElement("script");
      m.type = "text/javascript";
      m.src =
        "//webapi.amap.com/maps?v=1.4.15&key=672a0b0ad3864a331c9e2f2e62e45693&plugin=AMap.MarkerClusterer,AMap.Geocoder,AMap.MouseTool,AMap.Scale,AMap.ToolBar,AMap.MapType,AMap.RangingTool,AMap.Driving,AMap.Autocomplete";
      document.head.appendChild(m);
      m.onload = () => {
        newGaodeMap(mDiv).then(map => {
          resolve(map);
        });
      };
    }
  });
};
const newGaodeMap = function(mDiv) {
  return new Promise(resolve => {
    if (typeof AMap == "undefined") {
      setTimeout(() => {
        newGaodeMap(mDiv).then(map => {
          resolve(map);
        });
      }, 500);
    } else {
      setTimeout(() => {
        let map = new AMap.Map(mDiv, {
          lang: "zh-cn", //设置地图语言类型  zh-cn  en  zh-en
          resizeEnable: true,
          // zoom: zoom, //级别
          zooms: [3, 17]
          // center: [center.lon, center.lat] //中心点坐标
        });
        setTimeout(() => {
          map.addControl(new AMap.ToolBar());
          map.addControl(new AMap.Scale());
        }, 500);
        resolve(map);
      }, 500);
    }
  });
};
// 84 ——> 02
const ll84To02 = function(lng84 = 0, lat84 = 0) {
  let rObj = { lng: 0, lat: 0 };
  lng84 = parseFloat(lng84);
  lat84 = parseFloat(lat84);
  let mgLon = 0;
  let mgLat = 0;
  let a = 6378245.0;
  let ee = 0.00669342162296594323;
  let pi = Math.PI;
  if (outOfChina(lng84, lat84)) {
    mgLat = lat84;
    mgLon = lng84;
  } else {
    let dLon = transformLon(lng84 - 105.0, lat84 - 35.0);
    let dLat = transformLat(lng84 - 105.0, lat84 - 35.0);
    let radLat = (lat84 / 180.0) * pi;
    let magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    let sqrtMagic = Math.sqrt(magic);
    dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * pi);
    dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * pi);
    mgLat = lat84 + dLat;
    mgLon = lng84 + dLon;
  }
  rObj.lng = mgLon;
  rObj.lat = mgLat;
  return rObj;
};
const outOfChina = function(lng, lat) {
  if (lng < 72.004 || lng > 137.8347) {
    return true;
  }
  if (lat < 0.8293 || lat > 55.8271) {
    return true;
  }
  return false;
};
const transformLat = function(x, y) {
  let pi = 3.14159265358979324;
  let ret =
    -100.0 +
    2.0 * x +
    3.0 * y +
    0.2 * y * y +
    0.1 * x * y +
    0.2 * Math.sqrt(Math.abs(x));
  ret +=
    ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0) /
    3.0;
  ret +=
    ((20.0 * Math.sin(y * pi) + 40.0 * Math.sin((y / 3.0) * pi)) * 2.0) / 3.0;
  ret +=
    ((160.0 * Math.sin((y / 12.0) * pi) + 320 * Math.sin((y * pi) / 30.0)) *
      2.0) /
    3.0;
  return ret;
};
const transformLon = function(x, y) {
  let pi = 3.14159265358979324;
  let ret =
    300.0 +
    x +
    2.0 * y +
    0.1 * x * x +
    0.1 * x * y +
    0.1 * Math.sqrt(Math.abs(x));
  ret +=
    ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0) /
    3.0;
  ret +=
    ((20.0 * Math.sin(x * pi) + 40.0 * Math.sin((x / 3.0) * pi)) * 2.0) / 3.0;
  ret +=
    ((150.0 * Math.sin((x / 12.0) * pi) + 300.0 * Math.sin((x / 30.0) * pi)) *
      2.0) /
    3.0;
  return ret;
};
const getCenterInfo = function(llObjArr) {
  let aLng = [];
  let aLat = [];
  llObjArr.forEach(element => {
    aLng.push(element.lng);
    aLat.push(element.lat);
  });
  aLng.sort(function(a, b) {
    return a - b;
  }); //从小到大排序
  aLat.sort(function(a, b) {
    return a - b;
  });
  let lat_center = aLat[0] / 2 + aLat[aLat.length - 1] / 2;
  let lng_center = aLng[0] / 2 + aLng[aLng.length - 1] / 2;
  let lat_min = aLat[0];
  let lng_min = aLng[0];
  let lat_max = aLat[aLat.length - 1];
  let lng_max = aLng[aLng.length - 1];
  return { lat_center, lng_center, lat_min, lng_min, lat_max, lng_max };
};
const getNewLLByOld = function(opts) {
  let lng_diff = opts.lng_new - opts.lng_old;
  let lat_diff = opts.lat_new - opts.lat_old;
  let llObjArr_new = [];
  opts.llObjArr_old.forEach(llObj => {
    llObjArr_new.push({
      lng: llObj.lng * 1 + lng_diff,
      lat: llObj.lat * 1 + lat_diff
    });
  });
  return llObjArr_new;
};
// 02 ——> 84
const ll02To84 = function(lng02 = 0, lat02 = 0) {
  let lat84 = 0;
  let lng84 = 0;
  let rObj = { lng: 0, lat: 0 };
  if (outOfChina(lng02, lat02)) {
    rObj.lng = lng02;
    rObj.lat = lat02;
  } else {
    lat84 = lat02;
    lng84 = lng02;
    rObj = compare(lng02, lat02, lng84, lat84, DIFF);
  }
  return rObj;
};
const compare = function(lng02, lat02, lng84, lat84, diff) {
  let rObj = { lng: lng84, lat: lat84 };
  //构造矩形
  let lat84_min = lat84 - diff;
  let lng84_min = lng84 - diff;
  let lat84_max = lat84 + diff;
  let lng84_max = lng84 + diff;

  let lat02_min, lng02_min, lat02_max, lng02_max, lat02_mid, lng02_mid;

  //计算矩形中心的02坐标
  let llObj02_mid = ll84To02(lng84, lat84);
  lat02_mid = llObj02_mid.lat;
  lng02_mid = llObj02_mid.lng;

  //中心的02坐标与传入02坐标在规定范围内，直接返回
  if (
    Math.abs(lat02_mid - lat02) < PRECISION &&
    Math.abs(lng02_mid - lng02) < PRECISION
  ) {
    return rObj;
  }

  //计算最小最大点的02坐标
  let llObj02_min = ll84To02(lng84_min, lat84_min);
  lat02_min = llObj02_min.lat;
  lng02_min = llObj02_min.lng;

  let llObj02_max = ll84To02(lng84_max, lat84_max);
  lat02_max = llObj02_max.lat;
  lng02_max = llObj02_max.lng;

  //判断最大最小点的02坐标是否覆盖传入02坐标
  //超出范围
  if (
    lat02_min > lat02 ||
    lng02_min > lng02 ||
    lat02_max < lat02 ||
    lng02_max < lng02
  ) {
    if (lat02_min > lat02) {
      lat84 = lat84 - diff - lat02_min + lat02;
    } else if (lng02_min > lng02) {
      lng84 = lng84 - diff - lng02_min + lng02;
    } else if (lat02_max < lat02) {
      lat84 = lat84 + diff;
    } else if (lng02_max < lng02) {
      lng84 = lng84 + diff;
    }
    //扩大范围后重新计算，按道理应该不需要扩大范围
    rObj = compare(lng02, lat02, lng84, lat84, diff);
  } else {
    // //计算矩形中心的02坐标
    // llObj02_mid = ll84To02(lng84, lat84);
    // lat02_mid = llObj02_mid.lat;
    // lng02_mid = llObj02_mid.lng;

    //中心的02坐标与传入02坐标在规定范围内，直接返回
    if (
      Math.abs(lat02_mid - lat02) < PRECISION &&
      Math.abs(lng02_mid - lng02) < PRECISION
    ) {
      return rObj;
    } else {
      //将矩形划分为4个小矩形，判断传入02坐标在那个矩形内，并以覆盖矩形继续计算
      if (lat02 >= lat02_mid && lng02 <= lng02_mid) {
        //以小矩形的中心点为传入点，范围变为原来的1/2继续比较
        lat84 = lat84 + diff / 2;
        lng84 = lng84 - diff / 2;
        rObj = compare(lng02, lat02, lng84, lat84, diff / 2);
      } else if (lat02 <= lat02_mid && lng02 <= lng02_mid) {
        lat84 = lat84 - diff / 2;
        lng84 = lng84 - diff / 2;
        rObj = compare(lng02, lat02, lng84, lat84, diff / 2);
      } else if (lat02 <= lat02_mid && lng02 >= lng02_mid) {
        lat84 = lat84 - diff / 2;
        lng84 = lng84 + diff / 2;
        rObj = compare(lng02, lat02, lng84, lat84, diff / 2);
      } else if (lat02 >= lat02_mid && lng02 >= lng02_mid) {
        lat84 = lat84 + diff / 2;
        lng84 = lng84 + diff / 2;
        rObj = compare(lng02, lat02, lng84, lat84, diff / 2);
      }
    }
  }
  return rObj;
};
const getAcreage = function(llArr) {
  let acreage = 0;
  let obj = {
    type: "Polygon",
    coordinates: [llArr]
  };
  acreage = geojsonArea.geometry(obj);
  acreage = (acreage / Math.pow(1000, 2)).toFixed(3);
  return acreage;
};
const addInfoWinOper = function(tableStr, rOpts) {
  let infoStr = "";
  let operStr = "";
  if (rOpts.addMaker) {
    operStr +=
      "<a href='javascript:void(0);'><i class='e6-icon-location_line' title='添加点'></i></a>";
  }
  if (rOpts.gotoTrack) {
    operStr +=
      "<a href='javascript:void(0);'><i class='e6-icon-track_line' title='跳转轨迹'></i></a>";
  }
  if (operStr != "") {
    operStr = "<div class='win-oper'>" + operStr + "</div>";
  }
  infoStr = "<div class='win-info'>" + tableStr + operStr + "</div>";
  return infoStr;
};

// const initMap = function(mDiv, type) {
//   return new Promise((resolve, reject) => {
//     try {
//       document.getElementById(mDiv).innerHTML = "";
//       if (type == "gaode") {
//         let m = document.createElement("script");
//         m.type = "text/javascript";
//         m.src =
//           "http://webapi.amap.com/maps?v=1.4.15&key=672a0b0ad3864a331c9e2f2e62e45693&plugin=AMap.MarkerClusterer,AMap.Geocoder,AMap.MouseTool,AMap.Scale,AMap.ToolBar,AMap.MapType,AMap.RangingTool,AMap.Driving,AMap.Autocomplete";
//         document.head.append(m);
//         m.onload = () => {
//           let map = new AMap.Map(mDiv, {
//             lang: "zh-cn", //设置地图语言类型  zh-cn  en  zh-en
//             resizeEnable: true
//           });
//           resolve(map);
//         };
//       } else if (type == "mapbar") {
//         let m = document.createElement("script");
//         m.type = "text/javascript";
//         m.src = "http://api.mapbar.com/api/mapbard31.4.js"; // require("e6-module-map-service/utils/map/mapbarKey.js");
//         document.head.append(m);
//         m.onload = () => {
//           let maplet = new Maplet(mDiv);
//           maplet.centerAndZoom(new MPoint(114.054136, 22.541098), 11);
//           maplet.showOverview(false);
//           maplet.addControl(new MStandardControl());
//           resolve(maplet);
//         };
//       } else if (type == "google") {
//         let m = document.createElement("script");
//         m.type = "text/javascript";
//         m.src =
//           "//maps.google.cn/maps/api/js?key=AIzaSyCxmZqPDKY4NKST9_DoGJusyFDBdUCsx-M&sensor=true&v=3.37&language=ch-zh&libraries=places,drawing";
//         document.head.append(m);
//         m.onload = () => {
//           let llArr = [22.541098, 114.054136];
//           let myOptions = {
//             zoom: 11,
//             center: new google.maps.LatLng(llArr[0], llArr[1]),
//             mapTypeId: google.maps.MapTypeId.ROADMAP,
//             mapTypeControl: true,
//             mapTypeControlOptions: {
//               style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
//             },
//             overviewMapControl: false,
//             scaleControl: true,
//             fullscreenControl: false,
//             streetViewControl: false,
//             rotateControl: true,
//             zoomControl: true,
//             zoomControlOptions: {
//               position: google.maps.ControlPosition.LEFT_BOTTOM,
//               style: {
//                 width: 30,
//                 height: 60
//               }
//             },
//             minZoom: 4,
//             maxZoom: 20
//           };
//           let maplet = new google.maps.Map(
//             document.getElementById(mDiv),
//             myOptions
//           );
//           resolve(maplet);
//         };
//       }
//     } catch (e) {
//       reject(e);
//     }
//   });
// };
// 1、处理滚轮触发zoom变化事件；
// 2、处理下方操作
// that---地图api对象   overlay---覆盖物对象    extData---数据对象
const dealInfoWinOper = function(that, extData) {
  // 为了屏蔽地图的滚轮改变zoom，给window添加监听事件，来移除和添加scroll事件
  let wins = document.getElementsByName("win-table");
  wins.forEach(win => {
    win.addEventListener("mouseenter", function() {
      that.scrollWheel(false);
    });
    win.addEventListener("mouseleave", function() {
      that.scrollWheel(true);
    });
  });
  dealOper(extData);
  extData.type.indexOf("vehicle") > -1 && window.getWeatherInfo(extData);
};
const dealOper = function(extData) {
  let bottomBtns = Vue.extend({
    name: "bottomBtns",
    render() {
      let addMarker = (
        <div onclick={this.optionClick} data-type="addMarker" title="添加点">
          <i class="e6-icon-add-dot_line" data-type="addMarker" />
        </div>
      );
      let goTrack = (
        <div onclick={this.optionClick} data-type="goTrack" title="轨迹回放">
          <i class="e6-icon-track_line" data-type="goTrack" />
        </div>
      );
      let vehicleDetail = (
        <div
          onclick={this.optionClick}
          data-type="vehicleDetail"
          title="车辆信息"
        >
          <i class="e6-icon-truck_line" data-type="vehicleDetail" />
        </div>
      );
      let timeSearch = (
        <div
          onclick={this.optionClick}
          data-type="timeSearch"
          title="时间点查车"
        >
          <i class="e6-icon-time-check_line" data-type="timeSearch" />
        </div>
      );
      let photo = (
        <div onclick={this.optionClick} data-type="photo" title="闪拍">
          <i class="e6-icon-flash-pat_line" data-type="photo" />
        </div>
      );
      let navigation = (
        <div onclick={this.optionClick} data-type="navigation" title="导航">
          <i class="e6-icon-navigation_line" data-type="navigation" />
        </div>
      );
      let temprature = (
        <div
          onclick={this.optionClick}
          data-type="temprature"
          title="温度动态明细"
        >
          <i class="e6-icon-temperature_line" data-type="temprature" />
        </div>
      );
      let video = (
        <div onclick={this.optionClick} data-type="video" title="实时视频">
          <i class="e6-icon-video_line" data-type="video" />
        </div>
      );
      let editMarker = (
        <div onclick={this.optionClick} data-type="editMarker" title="修改">
          <i class="e6-icon-edit_line" data-type="editMarker" />
        </div>
      );
      let editArea = (
        <div onclick={this.optionClick} data-type="editArea" title="修改">
          <i class="e6-icon-edit_line" data-type="editArea" />
        </div>
      );
      let areaAlarm = (
        <div
          onclick={this.optionClick}
          data-type="areaAlarm"
          title="区域报警设置"
        >
          <i class="e6-icon-alarm_line" data-type="areaAlarm" />
        </div>
      );
      if (this.data.type == "vehicle") {
        return (
          <div>
            {addMarker}
            {goTrack}
            {vehicleDetail}
            {timeSearch}
            {photo}
            {navigation}
            {temprature}
            {video}
          </div>
        );
      } else if (this.data.type == "vehicle_map") {
        return (
          <div>
            {addMarker}
            {navigation}
          </div>
        );
      } else if (this.data.type == "marker") {
        return (
          <div>
            {editMarker}
            {areaAlarm}
            {navigation}
          </div>
        );
      } else if (this.data.type == "area") {
        return (
          <div>
            {editArea}
            {areaAlarm}
            {navigation}
          </div>
        );
      } else if (this.data.type == "start" || this.data.type == "end") {
        return (
          <div>
            {addMarker}
            {vehicleDetail}
            {navigation}
          </div>
        );
      } else {
        return null;
      }
    },
    props: ["data", "callBack"],
    methods: {
      optionClick(e) {
        this.callBack.call(null, this.data, e.target.dataset.type);
      }
    }
  });
  let btns = new bottomBtns({
    propsData: {
      data: { ...extData },
      callBack: optionClickCallback
    }
  }).$mount();
  setTimeout(() => {
    let winBottom = document.getElementById(
      `win-bottom-${extData.type}-${extData.id}`
    );
    if (!winBottom) return;
    if (winBottom.innerHTML == "") {
      winBottom.append(btns.$el);
    }
  }, 100);
};
// const dealWeather = function(data, extData) {
//   let wData = data[0] || {};
//   //摄氏度
//   let temperStr = "";
//   let t_night = wData.NightTempra;
//   let t_day = wData.DayTempra;
//   if (t_night == "") {
//     t_night = 0;
//   }
//   if (t_day == "") {
//     t_day = 0;
//   }
//   t_night = parseInt(t_night);
//   t_day = parseInt(t_day);
//   if (t_day == t_night) {
//     temperStr = t_day + "℃";
//   } else {
//     temperStr =
//       Math.min(t_day, t_night) + "℃ ~ " + Math.max(t_day, t_night) + "℃";
//   }
//   //天气
//   let weatherStr = "";
//   let w_night = wData.NightWeather;
//   let w_day = wData.DayWeather;
//   if (w_night == w_day) {
//     weatherStr = w_day;
//   } else {
//     weatherStr = w_day + "转" + w_night;
//   }
//   //当前时间（白天 or 晚上）
//   let cDate = new Date();
//   let iHour = cDate.getHours();
//   let src = require(`e6-module-map-service/assets/e6Images/weather/${
//     iHour > 6 && iHour < 18 ? wData.DayWeatherPic : wData.NightWeatherPic
//   }.gif`);
//   let title = weatherStr + " " + temperStr;
//   let img = `<img src='${src}' title='${title}' />`;

//   setTimeout(() => {
//     let winWeather = document.getElementById(
//       `win-weather-${extData.type}-${extData.vData.vehicleId}`
//     );
//     if (!winWeather) return;
//     if (!winWeather.hasChildNodes()) {
//       winWeather.innerHTML = img;
//     }
//   }, 10);
// };
const optionClickCallback = function(data, type) {
  switch (type) {
    case "addMarker":
      window.addMarker(data);
      break;
    case "goTrack":
      window.goTrackPage(data);
      break;
    case "vehicleDetail":
      window.goVehicleDetail(data);
      break;
    case "timeSearch":
      window.openTimeSearch(data);
      break;
    case "navigation":
      window.openLayer_navigation();
      break;
    case "editMarker":
      window.mEditById(data);
      break;
    case "editArea":
      window.aEditById(data);
      break;
  }
};
/*
 *   计算经纬度之间的距离(公里)
 */
const getDistance = function(lng1, lat1, lng2, lat2) {
  var radLat1 = (lat1 * Math.PI) / 180.0;
  var radLat2 = (lat2 * Math.PI) / 180.0;
  var a = radLat1 - radLat2;
  var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
  var s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
      )
    );
  s = s * 6378.137;
  s = Math.round(s * 10000) / 10000;
  radLat1 = null;
  radLat2 = null;
  a = null;
  b = null;
  return s;
};
/*
 *判断点是否在区域内
 */
//判断点(02坐标)是否在香港区域内
const isPointInHK = function(lon02, lat02) {
  lon02 = parseFloat(lon02);
  lat02 = parseFloat(lat02);
  var HKStr =
    "114.50441355319435,22.249999892647594;114.50443993961295,22.368126048048683;114.45971254142662,22.466006243124475;114.4599611599683,22.542254757750978;114.43884768753253,22.55932090471159;114.344184162758,22.565206463021347;114.28081502180774,22.562671018902346;114.2477793560842,22.55043259777784;114.23236040195029,22.541094108513626;114.22396081221211,22.551982474025873;114.20533830058012,22.55453972269849;114.1858636778768,22.55110903642457;114.18190816970951,22.55693640884497;114.16886549165515,22.556282253648927;114.16620633895373,22.559054819129546;114.16167796133432,22.552294621440392;114.15710142281712,22.55204329573786;114.15341156277034,22.538902216990667;114.13578028510814,22.539153556037714;114.11741633809717,22.526900820763483;114.11443681975999,22.533864294462987;114.10878771998825,22.528798614492355;114.10855507739781,22.532537916232336;114.09372327592442,22.53343707193792;114.08348778048558,22.52705622228592;114.09031657502031,22.521080118244324;114.08796245370561,22.51617247401333;114.08240871240294,22.512468576439378;114.07731556551114,22.51556035023105;114.06898855529884,22.513722117271967;114.05704842171406,22.499512110074636;114.02876351373768,22.505012706928436;114.01753996106691,22.497720366785614;114.00005749188864,22.50764657336277;113.952660425717,22.469371790345302;113.87398492346281,22.42579717853363;113.87396523778321,22.33031555294684;113.85229493623311,22.27015932886428;113.84392493006567,22.26479247430387;113.82209377441288,22.214179718613675;113.83732167052551,22.18096131238036;113.90135982635742,22.139561111546026;113.92718432055024,22.133772057053257;113.94436561774847,22.14553272502743;114.24078049550716,22.14569569642202;114.25929643465665,22.135940549792845;114.2887681363611,22.145716826576773;114.50439118472904,22.145698263611518;114.50441355319435,22.249999892647594"; //香港的02经纬度串。
  var TWStr =
    "120.1333333,25.3;122.0166667,25.3;122.0166667,21.88333333;120.1333333,21.88333333"; //台湾的02经纬度串。
  return (
    isPointInPolygon(lon02, lat02, HKStr) || isPointInRect(lon02, lat02, TWStr)
  );
};
//点和多边形关系
const isPointInPolygon = function(lon, lat, polygonStr) {
  lon = parseFloat(lon);
  lat = parseFloat(lat);
  //首先判断点是否在多边形的外包矩形内，如果在，则进一步判断，否则返回false
  if (!isPointInRect(lon, lat, polygonStr)) {
    return false;
  }

  var pts = new Array();
  var HKArr = polygonStr.split(";");
  for (var i = 0, len = HKArr.length; i < len; i++) {
    var oneHKArr = HKArr[i].split(",");
    pts.push({ lng: parseFloat(oneHKArr[0]), lat: parseFloat(oneHKArr[1]) });
  }

  var N = pts.length;
  var boundOrVertex = true; //如果点位于多边形的顶点或边上，也算做点在多边形内，直接返回true
  var intersectCount = 0; //cross points count of x
  var precision = 2e-10; //浮点类型计算时候与0比较时候的容差
  var p1, p2; //neighbour bound vertices
  var p = { lng: lon, lat: lat }; //测试点

  p1 = pts[0]; //left vertex
  for (var i = 1; i <= N; ++i) {
    //check all rays
    //				if(p.equals(p1)){
    //					return boundOrVertex;//p is an vertex
    //	}

    if (p.lng == p1.lng && p.lat == p1.lat) {
      return boundOrVertex; //p is an vertex
    }

    p2 = pts[i % N]; //right vertex
    if (p.lat < Math.min(p1.lat, p2.lat) || p.lat > Math.max(p1.lat, p2.lat)) {
      //ray is outside of our interests
      p1 = p2;
      continue; //next ray left point
    }

    if (p.lat > Math.min(p1.lat, p2.lat) && p.lat < Math.max(p1.lat, p2.lat)) {
      //ray is crossing over by the algorithm (common part of)
      if (p.lng <= Math.max(p1.lng, p2.lng)) {
        //x is before of ray
        if (p1.lat == p2.lat && p.lng >= Math.min(p1.lng, p2.lng)) {
          //overlies on a horizontal ray
          return boundOrVertex;
        }

        if (p1.lng == p2.lng) {
          //ray is vertical
          if (p1.lng == p.lng) {
            //overlies on a vertical ray
            return boundOrVertex;
          } else {
            //before ray
            ++intersectCount;
          }
        } else {
          //cross point on the left side
          var xinters =
            ((p.lat - p1.lat) * (p2.lng - p1.lng)) / (p2.lat - p1.lat) + p1.lng;
          if (Math.abs(p.lng - xinters) < precision) {
            return boundOrVertex;
          }

          if (p.lng < xinters) {
            ++intersectCount;
          }
        }
      }
    } else {
      //special case when ray is crossing through the vertex
      if (p.lat == p2.lat && p.lng <= p2.lng) {
        //p crossing over p2
        var p3 = pts[(i + 1) % N]; //next vertex
        if (
          p.lat >= Math.min(p1.lat, p3.lat) &&
          p.lat <= Math.max(p1.lat, p3.lat)
        ) {
          //p.lat lies between p1.lat & p3.lat
          ++intersectCount;
        } else {
          intersectCount += 2;
        }
      }
    }
    p1 = p2; //next ray left point
  }

  if (intersectCount % 2 == 0) {
    //偶数在多边形外
    return false;
  } else {
    //奇数在多边形内
    return true;
  }
};
//判断点是否在矩形区域内
const isPointInRect = function(lon, lat, rectStr) {
  //判断点
  var point = { lng: lon, lat: lat };
  //计算最大最小经纬度
  var rectArr = rectStr.split(";");
  var latArr = new Array();
  var lonArr = new Array();
  for (var i = 0, len = rectArr.length; i < len; i++) {
    var oneRectArr = rectArr[i].split(",");
    lonArr.push(parseFloat(oneRectArr[0]));
    latArr.push(parseFloat(oneRectArr[1]));
  }
  //改变js本身的排序方法
  //默认情况下sort方法是按ascii字母顺序排序的，而非我们认为是按数字大小排序
  lonArr.sort(function(a, b) {
    return a - b;
  }); //从小到大排序
  latArr.sort(function(a, b) {
    return a - b;
  });
  var minLon = lonArr[0];
  var maxLon = lonArr[lonArr.length - 1];
  var minLat = latArr[0];
  var maxLat = latArr[latArr.length - 1];

  //var sw = bounds.getSouthWest(); //西南脚点
  //var ne = bounds.getNorthEast(); //东北脚点
  var sw = { lng: minLon, lat: minLat };
  var ne = { lng: maxLon, lat: maxLat };
  return (
    point.lng >= sw.lng &&
    point.lng <= ne.lng &&
    point.lat >= sw.lat &&
    point.lat <= ne.lat
  );
};
//判断经纬度是否在bounds内
const isLLObjInBounds = function(llObj, bounds) {
  return (
    llObj.lon >= Math.abs(bounds.sw.lon) &&
    llObj.lon <= Math.abs(bounds.ne.lon) &&
    llObj.lat >= Math.abs(bounds.sw.lat) &&
    llObj.lat <= Math.abs(bounds.ne.lat)
  );
};
export {
  initGaode,
  ll84To02,
  ll02To84,
  getCenterInfo,
  getNewLLByOld,
  getAcreage,
  addInfoWinOper,
  // initMap,
  dealInfoWinOper,
  // dealWeather,
  getDistance,
  isPointInHK,
  isLLObjInBounds
};
